import { Button, CloseButton, Dialog, Portal } from "@chakra-ui/react";
import { Field } from "../ui/field";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { updatePromoCode } from "../../Redux/Action";

export const PromoCodeEditModal = ({ isOpen, onClose, data, refetchData }) => {
  const dispatch = useDispatch();
  const [promoCode, setPromoCode] = useState(data?.promoCode || "");
  const [isDisabled, setIsDisabled] = useState(false);

  const handleSubmit = () => {
    if (!promoCode || promoCode.trim() === "") {
      return;
    }

    setIsDisabled(true);
    dispatch(
      updatePromoCode({
        userId: data?._id,
        promoCode: promoCode.trim(),
        callback: (response) => {
          if (response?.meta?.code === 200) {
            onClose();
            refetchData();
          }
          setIsDisabled(false);
        },
      })
    );
  };

  return (
    <Dialog.Root lazyMount open={isOpen}>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title>Edit Promo Code</Dialog.Title>
            </Dialog.Header>
            <Dialog.Body>
              <Field label="Enter New Promo Code">
                <input
                  type="text"
                  value={promoCode}
                  onChange={(e) => setPromoCode(e.target.value)}
                  placeholder="Enter New Promo Code"
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    borderRadius: "6px",
                    border: "1px solid #e2e8f0",
                    fontSize: "14px",
                    boxSizing: "border-box",
                    transition: "border-color 0.2s, box-shadow 0.2s",
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = "#3182ce";
                    e.target.style.boxShadow = "0 0 0 3px rgba(49, 130, 206, 0.1)";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = "#e2e8f0";
                    e.target.style.boxShadow = "none";
                  }}
                />
              </Field>
            </Dialog.Body>
            <Dialog.Footer>
              <Button variant="outline" onClick={onClose}>
                Cancel
              </Button>
              <Button onClick={handleSubmit} disabled={isDisabled || !promoCode || promoCode.trim() === ""}>
                Submit
              </Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};
